<template>
  <div>
    <h2 class="title-2 text-left">Referências</h2>

    <p>
      <b>BRASIL. Ministério da Saúde.</b>
      Portaria GM/MS nº 3493, de 10 de abril de 2024. Altera a Portaria de
      Consolidação GM/MS nº 6, de 28 de setembro de 2017, para instituir nova
      metodologia de cofinanciamento federal do Piso de Atenção Primária à Saúde
      no âmbito do Sistema Único de Saúde (SUS). <b>Diário Oficial da União</b>,
      Brasília, DF, n. 70, seção 1, p. 100, 11 abr. 2024.
    </p>

    <p>
      <b>CONASEMS.</b>
      Estação SUS - Episódio 7 - Financiamento da Atenção Básica. [S.l.]:
      CONASEMS, 2024. 1 vídeo (34 min 22 s). Publicado pelo canal do CONASEMS.
      Disponível em: https://www.youtube.com/watch?v=D3yw0d88JAE. Acesso em: 25
      abr. 2024.
    </p>

    <p>
      <b>BRASIL. Ministério da Saúde. Gabinete da Ministra.</b>
      Portaria GM/MS nº 3.732, de 7 de maio de 2024. Define o valor per capita
      anual com base em critério populacional e estabelece a manutenção do valor
      nominal repassado no ano anterior para municípios com decréscimo
      populacional, válidos para o ano de 2024, no âmbito do Financiamento de
      Atenção Primária à Saúde.
      <b>Diário Oficial da União</b>: seção 1, Brasília, DF, 10 maio 2024. p.
      262.
    </p>

    <p>
      <b>MINISTÉRIO DA SAÚDE. Secretaria de Atenção Primária à Saúde.</b>
      Nota Metodológica: componente vínculo e acompanhamento territorial.
      Brasília, 2024. Disponível em:
      https://www.gov.br/saude/pt-br/centrais-de-conteudo/publicacoes/notas-tecnicas/2024/nota-metodologica.pdf.
      Acesso em: 15 jan. 2025.
    </p>

    <p>
      <b
        >BRASIL. Ministério da Saúde. Secretaria de Atenção Primária à Saúde.</b
      >
      Portaria SAPS/MS nº 161, de 10 de dezembro de 2024. Estabelece a
      metodologia de cálculo do Componente Vínculo e Acompanhamento Territorial.
      <b>Diário Oficial da União</b>, Brasília, DF, 20 dez. 2024. Seção 1, p.
      157. Disponível em:
      https://www.in.gov.br/web/dou/-/portaria-saps/ms-n-161-de-10-de-dezembro-de-2024-603288832.
      Acesso em: 15 jan. 2025.
    </p>

    <p>
      <b>BRASIL. Ministério da Saúde. Gabinete do Ministro.</b>
      Portaria GM/MS nº 10.254, de 23 de fevereiro de 2026. Define o valor per
      capita anual com base em critério populacional e estabelece a manutenção
      do valor nominal repassado no ano anterior para municípios com decréscimo
      populacional, válidos para o ano de 2026, no âmbito do Financiamento de
      Atenção Primária à Saúde - APS.
      <b>Diário Oficial da União</b>: seção 1, Brasília, DF, ed. 36, p. 67, 24
      fev. 2026. Disponível em:
      https://www.in.gov.br/web/dou/-/portaria-gm/ms-n-10.254-de-23-de-fevereiro-de-2026-688420429.
      Acesso em: 16 maio 2026.
    </p>

    <p>
      <b>BRASIL. Ministério da Saúde. Gabinete do Ministro.</b>
      Portaria GM/MS nº 10.994, de 13 de maio de 2026. Altera a Portaria GM/MS
      nº 3.493, de 10 de abril de 2024, para dispor sobre o período de
      implementação da metodologia de cofinanciamento federal do Piso de Atenção
      Primária à Saúde - APS no âmbito do Sistema Único de Saúde - SUS.
      <b>Diário Oficial da União</b>: seção 1, Brasília, DF, ed. 89, p. 1105, 14
      maio 2026. Disponível em:
      https://www.in.gov.br/en/web/dou/-/portaria-gm/ms-n-10.994-de-13-de-maio-de-2026-705373819.
      Acesso em: 16 maio 2026.
    </p>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
